// extracted by mini-css-extract-plugin
module.exports = {"spin":"animation__spin___PXbk2"};